import { IAssortmentLoadableState } from '../models/IAssortmentLoadableState'

export const resetAssortmentLoadableState = <T>(
  state: IAssortmentLoadableState<T>,
  message = ''
) => {
  state.data = []
  state.originalData = []
  state.message = message
}
